// eslint-disable-next-line prettier/prettier
import { Box, HStack, Header, Text, VStack, addWithConfig } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { getDesignToken, primitive, spacing } from 'styles/constants';
export const Item = VStack.withConfig({
  backgroundColor: getDesignToken('background-card'),
  borderRadius: primitive.$borderRadius,
  marginTop: '$4',
  borderBottomRadius: primitive.$borderRadius,
  borderTopRadius: primitive.$borderRadius,
});

export const ItemOffer = Box.withConfig<{ $isApplied?: boolean; isLoading?: boolean }>(p => ({
  backgroundColor: p.isLoading
    ? primitive.$blackOpacity10
    : p.$isApplied
    ? primitive.$successLight
    : primitive.$errorLight,
  borderRadius: 8,
  borderBottomRightRadius: 0,
  borderBottomLeftRadius: 0,
  paddingX: '$4',
  paddingY: '$3',
}));

export const ItemOfferFeedback = HStack.withConfig({
  focusable: true,
});

export const OfferFeedbackMessage = Text.withConfig({
  fontFamily: 'body',
  fontSize: '2xs',
  color: primitive.$bbqBrown,
  focusable: true,
  lineHeight: 'sm',
  flex: 1,
});

/** Flex spacers between actions: grow up to `$4`, shrink when the row is tight. */
export const CartItemEditButtonSpacer = Box.withConfig({
  flex: 1,
  minWidth: 0,
  maxWidth: '$4',
});

export const CartItemEditButtonContainerLeft = HStack.withConfig({
  flex: 1,
  minWidth: 0,
  alignItems: 'center',
  alignSelf: 'stretch',
});

export const CartItemEditButtonContainer = HStack.withConfig({
  alignItems: 'center',
  flexShrink: 0,
});

export const CartItemDescription = HStack.withConfig({
  paddingX: '$4',
  paddingY: '$2',
  alignItems: 'center',
  borderBottomWidth: 1,
  borderBottomColor: primitive.$blackOpacity10,
});

export const IncentiveName = Header.withConfig({
  margin: '$0',
  variant: 'headerTwo',
  focusable: true,
  fontSize: 'sm',
  lineHeight: 'sm',
});

export const CartItemInfoContainer = VStack.withConfig({
  flex: 1,
});

export const CartItemEditContainer = HStack.withConfig({
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTopWidth: 1,
  borderColor: getDesignToken('background-default'),
  paddingY: '$2',
  paddingX: '$4',
});

export const CartItemButton = addWithConfig(ActionButton).withConfig({
  variant: ActionButtonVariants.TEXT_ONLY,
  padding: 0,
  margin: 0,
});

export const CartItemButtonText = Text.withConfig({
  fontFamily: 'heading',
  lineHeight: '2xs',
  padding: '$2',
});

export const CartItemName = Header.withConfig({
  fontFamily: 'heading',
  fontSize: 'sm',
  margin: 0,
  focusable: true,
  numberOfLines: 2,
});

export const CartItemHeaderText = CartItemName.withConfig({
  flex: 1,
  minWidth: 0,
  marginLeft: spacing.$1,
  marginRight: spacing.$3,
  paddingY: '$3',
});

export const CartItemNameHeaderContainer = HStack.withConfig({
  borderBottomWidth: 1,
  borderBottomColor: 'blackOpacity.10',
  borderTopRadius: primitive.$borderRadius,
});

export const StyledLink = Text.withConfig({
  fontFamily: 'body',
  fontSize: '2xs',
  color: primitive.$bbqBrown,
  focusable: true,
  lineHeight: '16px',
  flex: 1,
  fontWeight: 'bold',
});
